module.exports = __webpack_public_path__ + "img/rightArrow.b6e7fa51.svg";